import Box from "@mui/material/Box";
import { useTranslationApp } from "../../../../../lib/i18next";
import Select from "../../../../../components/Form/Select";
import SelectBusinessAccount from "../../../../../components/Meta/SelectBusinessAccount";
import Typography from "@mui/material/Typography";
import {
  optionsAdsCampaignAdFormatLinkedin,
  optionsAdsCampaignObjectivesLinkedin,
} from "../../../../../utils/options";
import { LINKEDIN } from "../../../../../utils/constants";
import {
  AD_ACCOUNT_LINKEDIN_PLACEHOLDER,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_AD_FORMAT_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_IDENTITIES_ACCOUNTS_LABEL,
  CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_OBJECTIVE_LABEL,
  SELECT_A_OPTION,
} from "../../../../../i18n/keysTranslations";
import { LINKEDIN_DEFAULTS_FIELD_VISIBILITY } from "../../../../../utils/platformDefaults/platformDefaultsFieldVisibility";
import { PLATFORM_DEFAULTS_FIELD_LABEL_SX } from "../../../../../utils/platformDefaults/platformDefaultsFieldLabelSx";

const PlatformDefaultsFormLinkedin = ({ formMethods }) => {
  const { t } = useTranslationApp();
  const { control, setValue } = formMethods;

  const visibility = LINKEDIN_DEFAULTS_FIELD_VISIBILITY;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {visibility.objective ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography variant="body2" sx={PLATFORM_DEFAULTS_FIELD_LABEL_SX}>
            {t(CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_OBJECTIVE_LABEL)}
          </Typography>
          <Select
            options={optionsAdsCampaignObjectivesLinkedin}
            name="objective"
            variant="filled"
            fullWidth
            label={t(SELECT_A_OPTION)}
            doTranslate={true}
            control={control}
          />
        </Box>
      ) : null}

      {visibility.identities ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography variant="body2" sx={PLATFORM_DEFAULTS_FIELD_LABEL_SX}>
            {t(CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_IDENTITIES_ACCOUNTS_LABEL)}
          </Typography>
          <SelectBusinessAccount
            variant="filled"
            label={t(AD_ACCOUNT_LINKEDIN_PLACEHOLDER)}
            control={control}
            platform={LINKEDIN}
            name="adAccountID"
            onChangeAction={(value) => {
              setValue("integrationID", value?.integrationID);
            }}
            fullWidth={true}
          />
        </Box>
      ) : null}

      {visibility.adFormat ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography variant="body2" sx={PLATFORM_DEFAULTS_FIELD_LABEL_SX}>
            {t(CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_AD_FORMAT_LABEL)}
          </Typography>
          <Select
            options={optionsAdsCampaignAdFormatLinkedin}
            name="adFormat"
            variant="filled"
            fullWidth
            label={t(SELECT_A_OPTION)}
            doTranslate={true}
            control={control}
          />
        </Box>
      ) : null}
    </Box>
  );
};

export default PlatformDefaultsFormLinkedin;
